import React from 'react';
const stats = [{
  value: '26',
  label: 'Weeks planned'
}, {
  value: '78',
  label: 'Complete workouts'
}, {
  value: '6 + 5',
  label: 'Blocks & bonuses'
}, {
  value: 'PDF',
  label: 'Printable format'
}];
export function ProductFacts() {
  return <section aria-label="Product facts" className="bg-forest" data-id="element-214" data-mp="1kjkxz5o3twae">
      <div className="mx-auto max-w-6xl px-5" data-id="element-215" data-mp="1plsem8jvq0j2">
        <dl className="grid grid-cols-2 border-x border-moss md:grid-cols-4" data-id="element-216" data-mp="1pie9wtnqtf8g">
          {stats.map((s, i) => <div key={s.label} className={`bg-moss/40 px-3 py-8 text-center md:py-10 ${i % 2 === 1 ? 'border-l border-moss' : ''} ${i > 1 ? 'border-t border-moss md:border-t-0' : ''} ${i === 2 ? 'md:border-l' : ''}`} data-id="element-217" data-mp="2i964xnt2nxu7" data-mpi={i}>
              <dt className="sr-only" data-id="element-218" data-mp="suhu3r04qnya">{s.label}</dt>
              <dd data-id="element-219" data-mp="stowbfj5f8sa">
                <span className="block font-display text-5xl font-extrabold leading-none text-gold md:text-6xl" data-id="element-220" data-mp="st6s9wq8vq9t">
                  {s.value}
                </span>
                <span className="mt-2 block text-[11px] font-bold uppercase tracking-[0.16em] text-white/85 sm:text-xs" data-id="element-221" data-mp="qijffstvj1c2">
                  {s.label}
                </span>
              </dd>
            </div>)}
        </dl>
      </div>
    </section>;
}